import React from 'react';
import { SkeletonElement } from '../common';
import { css } from '@bts-web/utils-style-engine';

interface ButtonSkeletonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
}

export function OrdersListButtonSkeleton({
  children,
  variant = 'primary',
}: ButtonSkeletonProps) {
  return (
    <SkeletonElement
      height="56px"
      width="165px"
      className={css({
        display: 'flex',
        flexDirection: 'row',
        gap: 'extra_small_2',
        color: 'neutrals.text_disabled',
        backgroundColor:
          variant === 'primary'
            ? 'neutrals.fill_disabled'
            : 'neutrals.card_fill_primary',
        border: variant === 'secondary' ? '1px solid' : undefined,
        borderColor:
          variant === 'secondary' ? 'stroke_primary_disabled' : undefined,
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      {children}
    </SkeletonElement>
  );
}
